import { render, staticRenderFns } from "./StockProductsTemplate.vue?vue&type=template&id=617556c5&scoped=true&"
import script from "./StockProductsTemplate.vue?vue&type=script&lang=js&"
export * from "./StockProductsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StockProductsTemplate.vue?vue&type=style&index=0&id=617556c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617556c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
